export default __webpack_public_path__ + "static/media/07.30babca8.jpg";